export default "__VITE_ASSET__8c98747a__"